module.exports = __webpack_public_path__ + "img/thumbnail_KingPenguin_j_leucistic.b00adb74.png";